import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { PageHeader, Empty } from "@/components/common";
import { fmtDT } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function Notifiche() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const load = useCallback(() => {
    api.get("/notifications").then((r) => setData(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const open = async (n) => {
    await api.post(`/notifications/${n.id}/read`);
    if (n.link) nav(n.link); else load();
  };
  return (
    <div data-testid="notifiche-page">
      <PageHeader title="Notifiche" subtitle={data ? `${data.unread} da leggere` : ""}
        actions={<Button variant="outline" className="rounded-xl" onClick={() => api.post("/notifications/read-all").then(load)} data-testid="notifiche-read-all">Segna tutte lette</Button>} />
      {data?.items.length === 0 && <Empty text="Nessuna notifica." />}
      <div className="card-soft overflow-hidden">
        {data?.items.map((n) => (
          <button key={n.id} onClick={() => open(n)} data-testid={`notifiche-item-${n.id}`} className={cn("flex w-full items-start gap-3 border-b px-4 py-4 text-left last:border-0 hover:bg-muted/50", n.read && "opacity-60")}>
            <span className={cn("mt-2 h-2 w-2 shrink-0 rounded-full", n.read ? "bg-transparent" : "bg-primary")} />
            <div className="min-w-0 flex-1">
              <p className="font-semibold">{n.source === "toth" && <span className="text-primary">Toth · </span>}{n.title}{n.count > 1 && <span className="ml-1 text-xs text-muted-foreground">(×{n.count}, aggregata)</span>}</p>
              {n.body && <p className="mt-0.5 text-sm text-muted-foreground">{n.body}</p>}
              <p className="mt-1 text-xs text-muted-foreground">{fmtDT(n.updated_at)}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
